export default __webpack_public_path__ + "static/media/236.cd171cbd.jpg";